import { CircularProgress, Icon } from '@mui/material';
import MyGridView from 'components/GridView';
import Footer from 'examples/Footer';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import MyFunctions from 'functions/myFunctions';
import withAuth from 'functions/withAuth';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import newsService from 'services/newsService';
import offersService from 'services/offersService';

const NewsList = () => {
    const [data, setData] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    let navigate = useNavigate();

    function getAllData() {
        newsService.getAll().then(res => {
            setData([...res]);
            setIsDataLoaded(true);
        });
    }

    useEffect(() => {
        getAllData();
    }, []);

    if (!isDataLoaded) {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <CircularProgress color="success" size={60} />
                <p style={{ color: 'green' }}>الرجاء الإنتظار</p>
            </DashboardLayout>
        )
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div className="_container">
                <MyGridView
                    source={data}
                    columns={[
                        {
                            "field": "text",
                            "headerText": "العنوان",
                            "width": 70,
                            "textAlign": "right"
                        },
                        {
                            "field": "endDate",
                            "headerText": "تاريخ الانتهاء",
                            "width": 90,
                            "textAlign": "right",
                            "type": "date",
                            "format": "dd/MM/yyyy",
                        },
                    ]}
                    allowFiltering={true}
                    actionButtons={[
                        {
                            "content": <Icon color='info'>edit</Icon>,
                            "action": (id) => {
                                return navigate("/news/" + id)
                            }
                        },
                        {
                            "content": <Icon color='error'>delete</Icon>,
                            "action": (id) => {
                                MyFunctions.showConfirmationMessage("عملية حذف", "هل أنت متأكد من الحذف!", () => {
                                    newsService.delete(id).then(res => {
                                        getAllData();
                                    });
                                })
                            }
                        },
                    ]}
                    addAction={() => {
                        return navigate("/news/" + 0)
                    }}
                />
            </div>
            <Footer />
        </DashboardLayout>
    );
}

export default withAuth(NewsList);
